<template>
  <div>
    <h1>Teams</h1>
    <p>
      <v-switch v-model="archived" label="Show only archived teams"></v-switch>
    </p>
    <p>
      <v-btn :to="{name:'teamAdd'}">
        <v-icon>add</v-icon>Team
      </v-btn>
      <v-btn @click="updateFileTeamIdArchived">Update File Team Id Archived</v-btn>
    </p>
    <v-data-table
      :headers="headers"
      :items="teams"
      :pagination.sync="pagination"
      class="elevation-1"
      v-if="teams"
    >
      <template v-slot:items="props">
        <td>
          <v-btn :to="{name:'team', params:{id:props.item.id}}">{{props.item.id}}</v-btn>
        </td>
        <td>{{props.item.code}}</td>
        <td>{{props.item.name}}</td>
        <td>{{props.item.created | formatDateTime}}</td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "Teams",
  metaInfo() {
    return {
      title: "Teams",
      titleTemplate: "%s - Directory - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  data() {
    return {
      archived: false,
      teams: null,
      headers: [
        {
          text: "Id",
          value: "id"
        },
        {
          text: "Code",
          value: "code"
        },
        {
          text: "Name",
          value: "name"
        },
        {
          text: "Created",
          value: "created"
        }
      ],
      pagination: { sortBy: "code", rowsPerPage: -1 }
    };
  },
  methods: {
    fetchTeams() {
      nbmlaw
        .get(`/cors/admin/directory/teams/list/${this.archived}`)
        .then(response => {
          // console.log(response.data);
          this.teams = response.data;
        })
        .catch(() => {});
    },
    updateFileTeamIdArchived() {}
  },
  watch: {
    archived: {
      immediate: true,
      handler() {
        this.fetchTeams();
      }
    }
  }
};
</script>
